
import { Edit, SimpleForm, TextInput, DateInput, NumberInput } from 'react-admin';

export const Tbl_stagioneEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput source="id" disabled />
            <NumberInput source="legaId"  />
            <TextInput source="nome"  />
            <TextInput source="note"  />
            <NumberInput source="flVisibile"  />
            <NumberInput source="flAttivo"  />
            <NumberInput source="flAnnullato"  />
            <NumberInput source="ordinamento"  />
            <DateInput source="createdAt"  />
            <DateInput source="updatedAt"  />
        </SimpleForm>
    </Edit>
);
            